// ======================================================================
// 📁 File: src/modules/ticket/pages/TicketCreate.jsx
// 🎯 Purpose: Render ONLY CreateTicketForm — nothing else above it
// ======================================================================

import React from "react";
import CreateTicketForm from "../forms/CreateTicketForm";

export default function TicketCreate() {
  return <CreateTicketForm />;
}
